import { IonContent, IonPage } from '@ionic/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Icon } from '../chancey';
import { useChanceyTheme } from '../../theme/ThemeContext';
import { safeAreaPadding } from './safeArea';

export interface SupportPageLayoutProps {
  title: string;
  eyebrow?: string;
  fallbackPath?: string;
  children: React.ReactNode;
}

export const SupportPageLayout: React.FC<SupportPageLayoutProps> = ({
  title,
  eyebrow = 'Support',
  fallbackPath = '/settings',
  children,
}) => {
  const { c, typ, d } = useChanceyTheme();
  const history = useHistory();

  const goBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.replace(fallbackPath);
    }
  };

  return (
    <IonPage>
      <IonContent fullscreen style={{ '--background': c.bg }}>
        <div className="flex flex-col gap-[18px]" style={safeAreaPadding(8, d.pad, 24, d.pad)}>
          <div className="flex items-center gap-2 pt-1">
            <button
              type="button"
              onClick={goBack}
              aria-label="Back"
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border"
              style={{ borderColor: c.line, background: c.surface, color: c.ink }}
            >
              {Icon.back(18, c.ink)}
            </button>
            <div className="min-w-0 flex-1 px-0.5">
              <div
                className="text-xs font-medium uppercase tracking-[0.08em]"
                style={{ color: c.inkMuted, fontFamily: typ.body }}
              >
                {eyebrow}
              </div>
              <div
                className="mt-0.5 truncate text-[28px] leading-tight"
                style={{
                  fontFamily: typ.display,
                  fontWeight: typ.displayWeight,
                  letterSpacing: typ.displayLetter,
                  color: c.ink,
                }}
              >
                {title}
              </div>
            </div>
          </div>

          {children}
        </div>
      </IonContent>
    </IonPage>
  );
};
